import React from "react";
import { ReactComponent as Arrow } from "../../../resources/images/arrow.svg";
import "./UserInfoButton.scss"
import StateBadge from "../../badge/StateBadge";
import Skeleton from 'react-loading-skeleton';
import { TidStatusDto } from "../../../models/TidStatusDto";
import { TerminalItemDto } from "../../../models/TerminalInfoDto"
import { UserType } from "../../../utils/UserTypeEnum";

export class UserInfoButton extends React.Component<any, any>{
    render() {
        return this.props.isLoading ? (
            <Skeleton className={"user-info-button-container-skeleton"} />
        ) : (
            <div
                id={"user-info-button-container"}
                onClick={this.props.onClick}
                className={this.props.isAdmin ? "user-button-admin" : ""}
            >
                {
                    <div id={"user-info-button-content"}>
                        <div className={"user-info-content-details"}>
                            <div className={"user-info-button-main-content"}>
                                <div className={"user-info-content"}>
                                    <p className={"user-info-username"}>{this.props.user}</p>
                                    <p className={"user-info-role"}>{this.props.role}</p>
                                </div>
                                <div className="user-info-content">
                                    {this.props.userType === UserType.DEVELOPER ? (
                                        <StateBadge
                                            badgeStateText="attivo"
                                            userState={TidStatusDto.ACTIVE}
                                        />
                                    ) : (
                                        this.props.terminalList?.length === 0 ? (
                                            <StateBadge
                                                badgeStateText={this.props.sameTerminalsType ? "non assegnato" : "nessun ID terminale assegnato"}
                                                userState={TidStatusDto.NOT_ASSIGNED}
                                            />
                                        ) : (
                                            this.props.terminalList?.map((el: TerminalItemDto) => (
                                                this.props.sameTerminalsType ? (
                                                    <>
                                                        <p className="user-info-tid">ID Terminale: <b>{el.termId}</b></p>
                                                        <StateBadge userState={el.terminalStatus} />
                                                    </>
                                                ) : (
                                                    <div className={"user-info-content-badges"}>
                                                        <StateBadge userState={el.terminalStatus} />
                                                        <p className={"user-info-tid"}>
                                                            <b>
                                                                {el.terminalType === 'MPOS' || el.terminalType === null ? 'Mobile POS' : 'SoftPOS'}
                                                                {el.softposType === 'B' && ' di supporto'}
                                                                {el.softposType === 'A' && ' Aggiuntivo'}
                                                            </b>
                                                        </p>
                                                    </div>
                                                ))
                                            )
                                        )
                                    )}
                                </div>
                            </div>
                            <div id={"user-info-button-icon"}>
                                <Arrow className={"user-info-arrow-icon"} />
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}